import moment from "moment";
import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { createCrudActions } from '../utils/crudGenerator';

const formatAppointments = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        date: item.date && moment(item.date),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchAppointments,
    create: createAppointment,
    update: updateAppointment,
    delete: deleteAppointments
} = createCrudActions('APPOINTMENT', "Turno", formatAppointments);

export const fetchMonthlySchedule = (groupId, month, year) => {
    return async (dispatch) => {
        try {
            const response = await axios.get(`${API.appointments.schedule}/${groupId}/${month}/${year}`);

            // Guardar el schedule en el store
            dispatch({
                type: 'SET_MONTHLY_SCHEDULE',
                payload: response.data
            });

            // Guardar los parámetros actuales para poder recargar después
            dispatch({
                type: 'SET_CURRENT_SCHEDULE_PARAMS',
                payload: { groupId, month, year }
            });

            return response.data;
        } catch (err) {
            console.error("Error fetching monthly schedule:", err);
            throw err;
        }
    };
};

// Función para recargar el schedule actual
export const reloadCurrentSchedule = () => {
    return async (dispatch, getState) => {
        const params = getState().currentScheduleParams;
        if (params) {
            await dispatch(fetchMonthlySchedule(params.groupId, params.month, params.year));
        }
    };
};

export const fetchUserAppointmentByDate = (userId, date) => {
    return async (dispatch) => {
        try {
            const dateString = date.format ? date.format('YYYY-MM-DD') : date;
            const response = await axios.get(`${API.appointments.user}/${userId}/date/${dateString}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching user appointment by date:", error);
            return null;
        }
    };
};

export const createBulkAppointments = (appointments) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API.appointments.bulk}`, appointments);

            // Despachar acción para agregar los nuevos appointments al store
            if (response.data && response.data.appointments) {
                response.data.appointments.forEach(appointment => {
                    dispatch({
                        type: 'ADD_NEW_APPOINTMENT',
                        payload: formatAppointments(appointment)
                    });
                });
            }

            return response.data;
        } catch (error) {
            console.error("Error creating bulk appointments:", error);

            // Si hay errores de duplicados, aún podemos agregar los turnos que sí se crearon
            if (error.response?.status === 409 && error.response.data.insertedDocs) {
                error.response.data.insertedDocs.forEach(appointment => {
                    dispatch({
                        type: 'ADD_NEW_APPOINTMENT',
                        payload: formatAppointments(appointment)
                    });
                });
            }

            throw error;
        }
    };
};